import React from 'react';
import Table from '../UI/Table/Table';
import {getThumbnailImage} from '../HelperClasses/SingletonClass';
import placeholder from '../assets/pPlaceholder.png';
import ApproveButton from '../UI/Buttons/ApproveRejectButton';
import {useNavigate} from 'react-router-dom';

const AccountsListTable = ({
  onAccountClick,
  accounts_list,
  onApproveReject,
  readP,
  writeP,
  moderationWrite,
  account_columns,
}) => {
  const accountTableColumns = account_columns?.filter(
    it => it.feature_activated,
  );

  const navigate = useNavigate();

  return (
    <Table
      header_data={accountTableColumns?.map(item => {
        const center_keys = [
          'image',
          'status',
          'account_id',
          'account_status',
          'user_name',
          'email',
        ];
        const getColumnWidth = key => {
          switch (key) {
            case 'name':
              return 'min-w-[200px]';
            case 'image':
              return 'min-w-[100px]';
            case 'user_name':
              return 'min-w-[120px]';
            case 'email':
              return 'min-w-[120px]';
            case 'status':
            case 'account_status':
              return 'min-w-[120px]';
            default:
              return 'min-w-[140px]';
          }
        };

        return {
          title: item.title,
          key: item.key_name,
          className: [
            'text-sm font-medium px-4 py-3 flex-grow whitespace-nowrap',
            getColumnWidth(item.key_name),
            center_keys?.includes(item?.key_name)
              ? 'text-center'
              : 'text-start',
          ].join(' '),
        };
      })}
      table_header_style={'  '}
      table_style=" w-full block border-0 rounded-none !mt-0 table-auto w-full max-h-full h-full overflow-auto overflow-auto ">
      {accounts_list?.map(account => {
        return (
          <tr className="w-full border-b border-[#e6e7e7] bg-white">
            {accountTableColumns
              ?.filter(it => it?.feature_activated)
              ?.map(column => {
                switch (column.key_name) {
                  case 'name':
                    return (
                      <td
                        key={column.key_name}
                        onClick={() => navigate(`/account/${account?.id}`)}
                        className="p-2 text-primary min-w-[200px] cursor-pointer hover:underline">
                        {account?.name}
                      </td>
                    );

                  case 'description':
                    return (
                      <td
                        key={column.key_name}
                        className="px-4 whitespace-nowrap text-AppTitleBlack">
                        {account?.description?.length > 70
                          ? account?.description?.slice(0, 70) + '...'
                          : account?.description || 'N/A'}
                      </td>
                    );

                  case 'image':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2 whitespace-nowrap">
                        <img
                          src={
                            account?.images?.[0]
                              ? getThumbnailImage(account?.images?.[0])
                              : placeholder
                          }
                          alt={account?.name}
                          className="h-[50px] w-[50px] rounded-[10px] mx-auto"
                        />
                      </td>
                    );

                  case 'user_name':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2 text-AppTitleBlack text-center">
                        {account?.user?.first_name} {account?.user?.last_name}
                      </td>
                    );

                  case 'email':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2 text-AppTitleBlack text-center">
                        {account?.user?.email}
                      </td>
                    );

                  case 'status':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2 whitespace-nowrap">
                        {account?.active ? (
                          <p className="btn-active p-1 rounded w-fit mx-auto">
                            Active
                          </p>
                        ) : (
                          <p className="btn-deactivate p-1 rounded w-fit mx-auto">
                            Inactive
                          </p>
                        )}
                      </td>
                    );

                  case 'account_status':
                    return (
                      <td key={column.key_name} className="p-2">
                        {account?.status === 1 ? (
                          <div className="flex items-center justify-center gap-3">
                            <ApproveButton
                              is_approve={true}
                              onClickButton={() =>
                                onApproveReject({
                                  status: 2,
                                  account_id: account?.id,
                                })
                              }
                              disabled={!moderationWrite}
                            />
                            <ApproveButton
                              is_approve={false}
                              onClickButton={() =>
                                onApproveReject({
                                  status: 3,
                                  account_id: account?.id,
                                })
                              }
                              disabled={!moderationWrite}
                            />
                          </div>
                        ) : (
                          <p
                            className={`p-1 rounded w-fit mx-auto ${
                              account?.status === 2
                                ? 'btn-active'
                                : 'btn-deactivate'
                            }`}>
                            {account?.status === 2 ? 'Approved' : 'Rejected'}
                          </p>
                        )}
                      </td>
                    );

                  case 'location':
                    return (
                      <td
                        key={column.key_name}
                        className="p-2 px-4 text-AppTitleBlack">
                        <p className="line-clamp-1 text-sm break-words  overflow-hidden text-ellipsis">
                          {account?.location?.formatted_address
                            ? account?.location?.formatted_address
                            : 'N/A'}
                        </p>
                      </td>
                    );

                  default:
                    return null;
                }
              })}
          </tr>
        );
      })}
    </Table>
  );
};

export default AccountsListTable;
